import { memo } from 'react'
import { useParams } from 'react-router-dom'
import WhatWorkedPanel from '@/components/campaigns/adHistory/WhatWorkedPanel'

const CreativeInsights = memo(() => {
    const { id: campaignId } = useParams()

    return (
        <div className="tw:mx-auto tw:w-full tw:max-w-4xl tw:p-4">
            <WhatWorkedPanel campaignId={campaignId} />
        </div>
    )
})

CreativeInsights.displayName = 'CreativeInsights'

export default CreativeInsights
